import { render, staticRenderFns } from "./wechatpayDesktop.vue?vue&type=template&id=5c7f7592&scoped=true&"
import script from "./wechatpayDesktop.vue?vue&type=script&lang=js&"
export * from "./wechatpayDesktop.vue?vue&type=script&lang=js&"
import style0 from "./wechatpayDesktop.vue?vue&type=style&index=0&id=5c7f7592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f7592",
  null
  
)

export default component.exports